import {createFlexPuffSetting} from './createFlexPuffSetting';

const {SettingComponent: FlexPuffSetting} = createFlexPuffSetting();

export default FlexPuffSetting;
